module.exports = __webpack_public_path__ + "img/graph_pc.4329629.svg";